import React, {useState} from "react";
import {IActivatedViews, IRouteProps} from "../../ts/manager/view/ViewInterface";
import RouteChoice from "../../ts/model-factory/basic/route/RouteChoice";
import {getManager} from "../../ts/manager/Manager";
import NoContent from "../partial/status/NoContent";
import StateViewController from "../vc/StateViewController";
import LoadingPartial from "../partial/status/LoadingPartial";
import ContentBlocksStructure from "../partial/structure/ContentBlocksStructure";
import {IContentBlock} from "../../ts/data/subject/PostDataHelper";
import NavigationModel from "../../ts/manager/navigation/NavigationModel";


const FallbackRouteView = (props: IRouteProps) =>
{
    const [activatedMainViews] = useState<IActivatedViews|null>({});


    const viewState = StateViewController({
        routeProps: props
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    const choice = props.choice;
    let nextChoice:RouteChoice|null = null;
    let found = false;
    for(let i = getManager().navigation.model.levelList.length - 1; i >= 0; i--){
        const level = getManager().navigation.model.levelList[i];
        const altChoice = level.choice;
        if(altChoice?.realPath === choice.realPath){
            found = true;
            break;
        }
        if(altChoice?.nextFactoryID && level.model.factoryID !== "end_route"){
            nextChoice = altChoice;
        }
    }
    if(found && nextChoice){
        const choiceViewConfig = getManager().view.getChoiceViewConfig(nextChoice, false, activatedMainViews)
        return <div
            key={"fallback_view_"+choiceViewConfig.props.mainViewKey}
        >
            {choiceViewConfig.mainView}
        </div>
    }
    const contentBlocks:IContentBlock[] = (choice?.postDataChoice?.contentBlocks ?? []).slice();
    const postsContentBlock:IContentBlock = {
        acfFcLayout: "posts_layout",
    }
    if(choice && Object.keys(choice.routeIDs).length){
        let navigationModel:NavigationModel|null = null;
        if(choice.nextFactoryID && (choice.nextFactoryID !== "end_route")){
            navigationModel = getManager().navigation.createNavigationModel(choice.routeIDs);
            const finalModel = navigationModel.levelList[navigationModel.levelList.length - 1]?.model ?? null;
            postsContentBlock.posts = finalModel?.choiceList() ?? [];
        }
        if(!(postsContentBlock.posts ?? []).length){
            if(contentBlocks.length){
                navigationModel = navigationModel ? navigationModel : getManager().navigation.createNavigationModel(choice.routeIDs);
                if(navigationModel.levelList.length > 1){
                    const choiceModel = navigationModel.levelList[navigationModel.levelList.length - 2]?.model ?? null;
                    const choiceList = choiceModel?.choiceList() ?? [];
                    postsContentBlock.posts = [];
                    for(let altChoice of choiceList){
                        if(altChoice.id !== choice.id){
                            postsContentBlock.posts.push(altChoice);
                        }
                    }
                    if(postsContentBlock.posts.length){
                        postsContentBlock.title = "Read More";
                    }
                }

            }
        }
    }

    if((postsContentBlock.posts ?? []).length){
        contentBlocks.push(postsContentBlock);
    }

    if(!contentBlocks.length){
        return <section className="content-block">
            {getManager().navigation.routeIsProcessing ?
                <LoadingPartial {...props} /> :
                <NoContent {...props} />
            }
        </section>
    }

    return <>
        <ContentBlocksStructure blocks={contentBlocks}/>
    </>
}

export default FallbackRouteView;